import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const ratePerCommodityService = {
    fetchAll: async (params = {}) => {
      const response = await axiosInstance.get('/rate-per-commodity/paginate', {
        params,
      })
      return response.data
    },
    getById: async (id) => {
      const response = await axiosInstance.get('/rate-per-commodity/' + id)
      return response.data
    },
    store: async (data) => {
      const response = await axiosInstance.post('/rate-per-commodity', data)
      return response.data
    },
    update: async (data) => {
      const response = await axiosInstance.put(`/rate-per-commodity/${data.id}`, data)
      return response.data
    },
    delete: async (id) => {
      const response = await axiosInstance.delete(`/rate-per-commodity/${id}`)
      return response.data
    },
}